import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentWrapper } from '../common/wrapper/content/wrapper';
import { Card, Tabs, Typography } from '@otp/ui';
import { UserCard } from '../organisation/manage-otps/user-details/user-card';
import { RestaurantAssignedList } from '../organisation/manage-otps/user-details/restaurants/restaurants-assigned-list';
import { useAuthContext } from 'src/context/auth.context';
import { PermissionsAssigned } from '../organisation/manage-otps/user-details/permissions/permissions-assigned';
import { UserDetails } from './user-details';
import { Settings } from '@otp/icons';
import { UserEditCard } from './user-edit-card';
import { UserUserGroups } from '../organisation/manage-otps/user-details/user-groups/user-user-groups';
import { UserMergeRequestCard } from './user-merge-request-card';

enum TabType {
  Details = 'details',
  Stores = 'stores',
  Permissions = 'permissions',
}

export const UserProfile = () => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const [activeTab, setActiveTab] = useState(TabType.Details);

  const TABS = [
    { label: t('user-profile.tabs.details'), value: TabType.Details },
    { label: t('user-profile.tabs.stores'), value: TabType.Stores },
    { label: t('user-profile.tabs.permissions'), value: TabType.Permissions },
  ];

  if (!user) {
    return null;
  }

  return (
    <ContentWrapper>
      <Card
        noBorder
        className="bg-white flex grow gap-6 w-full flex-col md:flex-row p-3.5 md:p-4"
      >
        <div className="flex flex-col ">
          <UserCard user={user} />
          <Typography variant="subtitle1" className="pt-4 flex">
            <Settings className="pr-2" />
            {t('user-profile.actions.title')}
          </Typography>
          <div className="mt-2">
            <UserEditCard />
          </div>
          <div className="mt-2">
            <UserMergeRequestCard />
          </div>
        </div>
        <div className="flex flex-col grow gap-6">
          <Tabs
            tabs={TABS}
            onChange={(_, value) => setActiveTab(value)}
            value={activeTab}
          />
          {activeTab === TabType.Details && <UserDetails user={user} />}
          {activeTab === TabType.Stores && (
            <RestaurantAssignedList user={user} withoutActions />
          )}
          {activeTab === TabType.Permissions && (
            <>
              <PermissionsAssigned user={user} />
              <UserUserGroups userId={user.id} withoutActions />
            </>
          )}
        </div>
      </Card>
    </ContentWrapper>
  );
};
